export function isValueDef(channelDef) {
  return channelDef && 'value' in channelDef;
}
export function isNonValueDef(channelDef) {
  return channelDef && !('value' in channelDef);
}
export function isFieldDef(channelDef) {
  return channelDef && 'field' in channelDef && !!channelDef.field;
}
export function isTypedFieldDef(channelDef) {
  return isFieldDef(channelDef) && 'type' in channelDef && !!channelDef.type;
}
export function isScaleFieldDef(channelDef) {
  return isTypedFieldDef(channelDef) && 'scale' in channelDef;
}
export function isPositionFieldDef(channelDef) {
  return isTypedFieldDef(channelDef) && 'axis' in channelDef;
}